import { createSelector } from 'reselect';
import {
    removeAllHTMLAndUnicodeSymbols,
    getFullPath,
} from '../../../helpers/helpers';
import moment from 'moment';
import { NewsReduxType, NewsSelectorType } from '../types';
import { CategoriesReduxType, TagsReduxType } from 'store/ducks/app/types';
import { isAuthorNull } from '../../../helpers/isAuthorNull.helpers';

const categories = (state: { initdata: { categories: CategoriesReduxType } }) =>
    state.initdata.categories;

const tags = (state: { initdata: { tags: TagsReduxType } }) =>
    state.initdata.tags;

const newsOne = (state: { newsOne: { newsOne: NewsReduxType } }) =>
    state.newsOne.newsOne;

export const newsOneSelector = createSelector(
    [newsOne, categories, tags],
    (newsOne, categories, tags) => {
        let renderNewsOne: NewsSelectorType = null;

        const isTrue =
            newsOne &&
            Object.keys(categories).length &&
            Object.keys(tags).length;

        if (isTrue) {
            let type = 'news';
            let slug = newsOne.slug;
            // if (slug.indexOf('/news') === -1) {
            //     slug = '/news' + slug;
            // }
            let object = {
                id: newsOne.id,
                date: moment(newsOne.date).format('DD.MM.YYYY'),
                // categories: mapArrayNumberToStringValues(
                //     newsOne.categories,
                //     categories
                // ),
                image: newsOne.images.large || '',
                title: newsOne.additional.htmlTitle || newsOne.title.rendered,
                // description: removeAllHTMLAndUnicodeSymbols(
                //     newsOne.excerpt.rendered
                // ),
                cover: {
                    author: isAuthorNull(newsOne.cover.author),
                },
                tag: '',
                content: newsOne.content.rendered,
                og: newsOne.og,
                type: newsOne.type || type,
                slug,
            };

            renderNewsOne = { ...object };
        }
        return { newsOne: renderNewsOne };
    }
);
